import React, {useState} from 'react'
import ReactDOM from 'react-dom';
import { AppProvider as PolarisProvider } from "@shopify/polaris";
import { Provider as AppBridgeProvider } from "@shopify/app-bridge-react";
import '@shopify/polaris/build/esm/styles.css';
import translations from "@shopify/polaris/locales/en.json";
import {BrowserRouter} from "react-router-dom";
import axios from 'axios';

import reportWebVitals from './reportWebVitals';
import RoutesWithPropagation from "./RoutesWithPropagation";
import Login from "./components/Login";
import {apiOrigin} from "./util/AxiosUtil";

// Setup axios
(function () {
    // console.log("Setting up axios");
    const apiBaseURL = apiOrigin();
    if (apiBaseURL) {
        //console.log("Setting API baseURL to ", apiBaseURL);
        axios.defaults.baseURL = apiBaseURL;
        axios.defaults.withCredentials = true;
    }

    /*
    // Unauthorised Interceptor
    axios.interceptors.response.use(function (response) {
        // Nothing to do here.
        return response;
    }, function (error) {
        // Logout when unauthorised response status is received
        if (error.response && error.response.status === 401) {
            store.dispatch(changeUser(null));
        }
        return Promise.reject(error);
    });

    // Selected Customer Interceptor
    axios.interceptors.request.use((config) => {
        const state = store.getState();
        if (state && state.auth && state.auth.selectedCustomer && state.auth.selectedCustomer.id) {
            config.headers['CustomerId'] = state.auth.selectedCustomer.id;
        }
        return config;
    })

     */

})();

function MyProvider(props: any) {
    const [ isLoggedIn, setIsLoggedIn ] = useState(false);

    const onLoginSuccess = () => {
        setIsLoggedIn(true);
    }

    return (
        <BrowserRouter>
            <Login onSuccess={onLoginSuccess} />
            {isLoggedIn && <RoutesWithPropagation />}
        </BrowserRouter>
    );
}

function MyApp(props: any) {
    const url = new URL(window.location.href);
    const host = new URLSearchParams(url.search).get('host');
    if (!host) {
        // If no "host" query param was provided then assume
        // the app is not installed and redirect to api auth
        console.error("NO HOST!", url.search);
        if (url.search !== "") {
            window.location.href = apiOrigin() + "/shopify/v1/auth" + url.search;
            return null;
        }
        return (
            <h1 style={{padding: "20px"}}>Shopify App.  &copy; SubTrux Pty Ltd</h1>
        );
    }

    return (
        // @ts-ignore
        <PolarisProvider i18n={translations}>
            <AppBridgeProvider
                config={{
                    apiKey: "bdcfec0f636cec9f358305bded3102c2", // TODO: Externalise this
                    host: host,
                    forceRedirect: true,
                }}
            >
                <MyProvider {...props} />
            </AppBridgeProvider>
        </PolarisProvider>
    );
}

ReactDOM.render(
    <React.Fragment>
        <MyApp />
    </React.Fragment>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
